
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/home/canvas/public-html/ui/shared/outcomes/content-view/jst/-criterionHeader';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  buffer += "<th class=\"rating-header\" aria-label='";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "'>\n  <div class='rating-wrap'>\n    <h5>";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</h5>\n    <div class=\"insert\">\n      <a href=\"#\" class=\"insert_rating\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.criterion_header")
  },data:data},helper ? helper.call(depth0, "outcomes.criterion_header.insert_criterion_rating", "Insert criterion rating", options) : helperMissing.call(depth0, "t", "outcomes.criterion_header.insert_criterion_rating", "Insert criterion rating", options)))
    + "\" tabindex=0 role=button aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.criterion_header")
  },data:data},helper ? helper.call(depth0, "outcomes.criterion_header.insert_criterion_rating", "Insert criterion rating", options) : helperMissing.call(depth0, "t", "outcomes.criterion_header.insert_criterion_rating", "Insert criterion rating", options)))
    + "\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("outcomes.criterion_header")
  },data:data},helper ? helper.call(depth0, "outcomes.criterion_header.insert_rating", "Insert", options) : helperMissing.call(depth0, "t", "outcomes.criterion_header.insert_rating", "Insert", options)))
    + "\n        <span class=\"arrow-icon\"></span>\n      </a>\n    </div>\n  </div>\n</th>\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/shared/outcomes/content-view/jst/_criterionHeader.handlebars', templates['/home/canvas/public-html/ui/shared/outcomes/content-view/jst/-criterionHeader']);
    ;
    ;
    export default templates[name];
  